const routes = [
  {
    path: '/violation', // 罚单管理模块
    name: 'violation',
    component: () => import('@src/modules/violation/main'),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: 'list', // 罚单列表页面
        name: 'violationList',
        component: () => import('@src/modules/violation/view/list'),
        meta: {
          requireAuth: true,
          routerAlive: true
        },
      },
    ],
  },
]

export default routes
